// extracted by mini-css-extract-plugin
export default {"container":"PaginaInicial_container__PLnUy","titulo":"PaginaInicial_titulo__36k+E"};